import { Loading } from 'quasar'
import { boot } from 'quasar/wrappers'

export default boot(({ router, store, redirect }) => {
  router.beforeEach((to, from, next) => {
    Loading.show()
    if (store.getters['auth/isAuthenticated'] && to.name != 'monitor') {
      next({ name: 'monitor' })
    } else {
      next()
    }
  })

  router.afterEach(() => {
    Loading.hide()
  })
})
